/**
 * 客户端版本号工具
 */
import useragent from '@common/useragent'

// 获取客户端当前版本号
const appVersion = (useragent.isSuishouji || useragent.isKaniu) ? useragent.detail.app.version : ''

/**
 * 版本号比较
 * featureVersion: 特性版本号
 * 说明：如果当前版本号大于或等于特性版本号，返回true，否则返回false
 */
export const compare = (featureVersion, currentVersion = appVersion) => {
  try {
    // 无法获取正确的版本号
    if (!currentVersion) {
      return false
    }
    // 版本号一致
    if (currentVersion === featureVersion) {
      return true
    }
    // 逐位比较返回结果
    const currents = currentVersion.split('.')
    const targets = featureVersion.split('.')
    const length = currents.length > targets.length ? currents.length : targets.length
    let currentSubVersion
    let targetSubVersion
    for (let i = 0; i < length; i++) {
      currentSubVersion = typeof (currents[i]) === 'undefined' ? 0 : currents[i]
      targetSubVersion = typeof (targets[i]) === 'undefined' ? 0 : targets[i]
      if (~~currentSubVersion > ~~targetSubVersion) {
        return true
      } else if (~~currentSubVersion < ~~targetSubVersion) {
        return false
      }
    }
    return false
  } catch (e) {
    // 错误情况下默认返回false
    return false
  }
}

/**
 * 排序版本号
 * versions{String,Array}:需要排除的版本号
 * 说明：当前版本号在排除版本号中返回true，否则返回false
 */
export const splice = (versions) => {
  if (typeof versions === 'string') {
    if (appVersion === versions) {
      return true
    }
    return false
  } else if (versions instanceof Array) {
    const length = versions.length
    for (let i = 0; i < length; i++) {
      if (appVersion === versions[i]) {
        return true
      }
    }
    return false
  }
  return false
}

export default {
  compare,
  splice
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/version.js